<template>
  <transition name="fade">
    <div class="modal-card-wrapper">
      <span @click="$emit('close')">&#x2715;</span>
      <div class="modal-card">
        <img src="@/assets/icon-upholstery-colors.svg" alt="Color upholstery logo" class="illustration">
        <div class="text">
          <b>Upholstery Color</b>
          Select from 9 colors or call for 21 custom colors (+$90.00)
          <small><slot></slot></small>
        </div>
      </div>
      <div>
        <h4>Standard Colors</h4>
        <div class="text margin-bottom-10">Free upgrade option colors are included with the price of your equipment.</div>
          <div class="flex">
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/02-adobe-white.jpg" width="73" height="44" />
                <br />
                Adobe White
            </div>
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/01-black.jpg" width="73" height="44" />
                <br />
                Black
            </div>
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/08-burgundy.jpg" width="73" height="44" />
                <br />
                Burgundy
            </div>            
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/07-dark-cherry.jpg" width="73" height="44" />
                <br />
                Dark Cherry
            </div>
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/03-greystone.jpg" width="73" height="44" />
                <br />
                Greystone
            </div>
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/04-oak.jpg" width="73" height="44" />
                <br />
                Oak
            </div>
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/05-sage.jpg" width="73" height="44" />
                <br />
                Sage
            </div>
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/51-storm.jpg" width="73" height="44" />
                <br />
                Storm
            </div>            
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/06-wedgewood.jpg" width="73" height="44" />
                <br />
                Wedgewood
            </div>
          </div>
          <h4>Custom Colors</h4>
          <div class="text margin-bottom-10">Choose from 21 custom colors.</div>
          <div class="flex">
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/2032-54_Admiral-HR.jpg" width="73" height="44" />
                <br />
                admiral
            </div>            
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/13-bronze.jpg" width="73" height="44" />
                <br />
                bronze
            </div>
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/46-cinnabar.jpg" width="73" height="44" />
                <br />
                cinnabar
            </div>
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/US-357_Claret.jpg" width="73" height="44" />
                <br />
                claret
            </div>            
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/38--deep-violet.jpg" width="73" height="44" />
                <br />
                deep violet
            </div> 
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/US-519_Doe.jpg" width="73" height="44" />
                <br />
                doe
            </div>                       
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/22-dove.jpg" width="73" height="44" />
                <br />
                dove
            </div>  
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/33-fjord-blue.jpg" width="73" height="44" />
                <br />
                fjord blue
            </div>
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/US-344_Forest.jpg" width="73" height="44" />
                <br />
                forest
            </div> 
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/39-golden-corn.jpg" width="73" height="44" />
                <br />
                golden corn
            </div>                      
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/24-graphite.jpg" width="73" height="44" />
                <br />
                graphite
            </div>  
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/31-grotto.jpg" width="73" height="44" />
                <br />
                grotto
            </div>                    
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/17-mocha.jpg" width="73" height="44" />
                <br />
                mocha
            </div>
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/US-529_Olive_Green.jpg" width="73" height="44" />
                <br />
                olive green
            </div> 
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/2034-54_Orange-Ochre-HR.jpg" width="73" height="44" />
                <br />
                orange ochre
            </div>  
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/US-385_Parchment.jpg" width="73" height="44" />
                <br />
                parchment
            </div>
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/2031-54_Platinum-HR.jpg" width="73" height="44" />
                <br />
                platinum
            </div>            
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/15-putty.jpg" width="73" height="44" />
                <br />
                putty
            </div>
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/2036-54_Russet-HR.jpg" width="73" height="44" />
                <br />
                russet
            </div>            
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/10-sand.jpg" width="73" height="44" />
                <br />
                sand
            </div>            
            <div class="swatch">
                <img src="https://s3.amazonaws.com/s3.pilates.com/img/store/upholstery-swatches-new/14-taupe.jpg" width="73" height="44" />
                <br />
                taupe
            </div>
          </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'modalcardlarge'
}
</script>

<style lang="scss" scoped>
.modal-card-wrapper {
  width: 100%;
  background-color: var(--white);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-bottom: 6px solid var(--black);
  position: relative;
  padding: 0 20px;
  z-index: 1000;
}

span {
  position: absolute;
  right: 15px;
  top: 10px;
  font-size: 30px;
  line-height: 1;
  cursor: pointer;
}

.modal-card {
  display: flex;
  height: 153px;
  align-items: center;
}

.swatch {
  font-size: 0.625rem;
  text-transform: capitalize;
}

.illustration {
  display: block;
  margin-right: 20px;
  margin-top: -40px;
  width: 32px;
}

.text {
  align-self: center;
  font-family: var(--roboto);
  color: var(--black);
  font-size: 0.875rem;
  line-height: 1.214;
}

.text b{
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.3125;
  display: block;
  margin: 10px 0;
}

.text small {
  font-style: italic;
  font-size: 0.75rem;
  line-height: 1.25;
  display: block;
  margin: 10px 0;
}

.margin-bottom-10 {
  margin-bottom: 10px;
}

h4 {
  margin-top: 0;
  margin-bottom: 5px;
}

.flex {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 25px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
